<template>
  <div>
    <b-modal
      id="delete-business-type-modal"
      hide-footer
      @hidden="$emit('hidden')"
    >
      <div class="d-flex flex-column align-items-center justify-content-center">
        <h4>
          Are you sure you want to delete {{ businessTypeName }} ?
        </h4>
      </div>
      <div class="mt-1 d-flex justify-content-around">
        <b-button
          variant="primary"
          :disabled="loadingDeleteBtn"
          @click="deleteBusinessType"
        >
          <b-spinner
            v-if="loadingDeleteBtn"
            small
          />
          <span v-else>Delete</span>

        </b-button>
        <b-button
          variant="outline-danger"
          @click="$bvModal.hide('delete-business-type-modal')"
        >
          Cancel
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import { BModal, BButton, BSpinner } from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'

export default {
  components: {
    BModal, BButton, BSpinner,
  },
  props: {
    businessType: {
      type: Object,
      default: undefined,
    },
  },
  setup(props, ctx) {
    const loadingDeleteBtn = ref(false)
    const businessTypeName = computed(() => (props.businessType ? props.businessType.label : ''))
    const deleteBusinessType = async () => {
      try {
        loadingDeleteBtn.value = true
        await ctx.root.$store.dispatch('business/deleteBusinessType', props.businessType.id)
        ctx.root.$bvModal.hide('delete-business-type-modal')
        ctx.emit('deleted')
      } catch (error) {
        console.log(error)
      } finally {
        loadingDeleteBtn.value = false
      }
    }

    return {
      deleteBusinessType,
      businessTypeName,
      loadingDeleteBtn,
    }
  },

}

</script>
